import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )

  return Yup.object({
    userGroupCompanyId: Yup.number().required(requiredMessage),
    userGroupMasterId: Yup.number().required(requiredMessage),
    createdBy: Yup.number(),
    createdDate: Yup.string(),
    updatedBy: Yup.number(),
    updatedDate: Yup.string(),
  })
}

export default makeValidationSchema
